import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaTachometerAlt,
  FaChalkboardTeacher,
  FaUsers,
  FaBook,
  FaClipboardList,
  FaSignOutAlt,
  FaQrcode,
} from 'react-icons/fa';

const Sidebar = ({ role = 'admin' }) => {

  let navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    navigate("/login");
  }

  return (
    <aside className="sidebar">
      <ul className="sidebar-menu">
        <li>
          <Link to={`/${role}`}>
            <FaTachometerAlt className="icon" /> Dashboard
          </Link>
        </li>

        {role === 'admin' && (
          <>
            <li>
              <Link to="students">
                <FaUsers className="icon" /> Manage Students
              </Link>
            </li>
            <li>
              <Link to="enroll-student">
                <FaUsers className="icon" /> Enroll Students
              </Link>
            </li>
            <li>
              <Link to="teachers">
                <FaChalkboardTeacher className="icon" /> Manage Teachers
              </Link>
            </li>
            <li>
              <Link to="assign-subject">
                <FaChalkboardTeacher className="icon" /> Assign Subjects
              </Link>
            </li>
            <li>
              <Link to="programs">
                <FaBook className="icon" /> Programs
              </Link>
            </li>
            <li>
              <Link to="semesters">
                <FaClipboardList className="icon" /> Semesters
              </Link>
            </li>
            <li>
              <Link to="subjects">
                <FaBook className="icon" /> Subjects
              </Link>
            </li>
            <li>
              <Link to="attendance">
                <FaClipboardList className="icon" /> Attendance Logs
              </Link>
            </li>
          </>
        )}

        {role === 'teacher' && (
          <>
            <li>
              <Link to="/teacher/attendence">
                <FaClipboardList className="icon" /> Take Attendance
              </Link>
              <Link to="/teacher/session-attendance">
                <FaUsers className='icon'/> View Attendance
              </Link>
            </li>
            {/* Add more teacher links here */}
          </>
        )}

        {role === 'student' && (
          <>
            <li>
            </li>
            <li>
              <Link to="scan">
                <FaQrcode className="icon" /> Scan
              </Link>
            </li>
            {/* Add more student links here */}
          </>
        )}
      </ul>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={() => logout()}>
          <FaSignOutAlt className="icon" /> Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
